var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d5ee68c6fbb7fd51fbd7fee8ece0b955b9e75b4d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["buscounchollo-prod@sentry"]={id:"d5ee68c6fbb7fd51fbd7fee8ece0b955b9e75b4d"};
      